// extracted by mini-css-extract-plugin
export default {"Emojify":"bbq_a bhr_g"};